import { AuthProvider } from '@descope/react-sdk';
import type { PropsWithChildren } from 'react';

const DESCOPE_PROJECT_ID = import.meta.env.VITE_DESCOPE_PROJECT_ID as string;

export function DescopeAuthProvider({ children }: PropsWithChildren) {
  if (!DESCOPE_PROJECT_ID) return <>{children}</>;

  return <AuthProvider projectId={DESCOPE_PROJECT_ID}>{children}</AuthProvider>;
}
